import Accordion from "@/common/components/Accordion"
import SelectController from "@/common/components/SelectController"
import { EstablishmentLeadsFunnelUpdateContractValidationSchema } from "@/features/establishmentLeadsFunnel/schemas/update.schema"
import { ContractData } from "@/features/establishmentLeadsFunnel/types/establishmentLead.type"
import { establishmentOptions as cycleOptions } from "@/features/privateCompanyLeadsFunnel/constants/cycleOptions.constant"
import { options as monthDaysOptions } from "@/features/privateCompanyLeadsFunnel/constants/monthDaysOptions.constant"
import { options as weekDaysOptions } from "@/features/privateCompanyLeadsFunnel/constants/weekDaysOptions.constants"
import { useMemo } from "react"
import { Control, FieldErrors, UseFormSetValue, UseFormWatch } from "react-hook-form"

interface CmContractInvoiceDetailsProps {
  maintenanceContract?: ContractData
  control: Control<EstablishmentLeadsFunnelUpdateContractValidationSchema, any>
  submit: () => void
  watch: UseFormWatch<EstablishmentLeadsFunnelUpdateContractValidationSchema>
  setValue: UseFormSetValue<EstablishmentLeadsFunnelUpdateContractValidationSchema>
  disableFields?: boolean
  errors: FieldErrors<EstablishmentLeadsFunnelUpdateContractValidationSchema>
}

export const CmContractInvoiceDetails = ({
  maintenanceContract,
  control,
  submit,
  watch,
  setValue,
  disableFields,
  errors,
}: CmContractInvoiceDetailsProps) => {
  const watchCycle = watch('maintenance_contract.cycle');

  const getCycleStartDayDefaultValue = useMemo(() => {
    if (maintenanceContract?.cycle === 'weekly') {
      if (maintenanceContract?.cycle_start_day !== null && maintenanceContract?.cycle_start_day !== undefined) {
        return weekDaysOptions[maintenanceContract?.cycle_start_day];
      }

      return '';
    }

    return monthDaysOptions.find(({ value }) => value === `${maintenanceContract?.cycle_start_day}`);
  }, [maintenanceContract?.cycle]);

  return (
    <Accordion
      name="maintenance_contract_invoice_details"
      className="p-0"
      triggerClassName="p-4"
      contentClassName="p-4 pt-0"
      defaultOpen
      head={
        <p>Detalhes da fatura</p>
      }
      body={
        <div className="flex flex-col gap-4">
          <SelectController
            control={control}
            name="maintenance_contract.cycle"
            label="Ciclo de fatura"
            defaultValue={cycleOptions.find(({ value }) => value === maintenanceContract?.cycle)}
            options={cycleOptions}
            triggerOnChange={() => {
              setValue('cycle_start_day', null);
              submit();
            }}
            isDisabled={disableFields}
            errorMessage={errors.cycle?.message || ' '}
            markAsRequired
          />
          <div className="flex gap-2">
            <SelectController
              control={control}
              name="maintenance_contract.cycle_start_day"
              label="Dia de abertura"
              className="w-1/2"
              defaultValue={getCycleStartDayDefaultValue}
              options={
                (watchCycle?.value || maintenanceContract?.cycle) === 'weekly'
                  ? weekDaysOptions
                  : monthDaysOptions(28)
              }
              triggerOnChange={submit}
              isDisabled={disableFields}
              errorMessage={errors.cycle_start_day?.message || ' '}
              markAsRequired
            />
            <SelectController
              control={control}
              name="maintenance_contract.closing_to_due_in_days"
              label="Vencimento da fatura"
              className="w-1/2"
              defaultValue={
                monthDaysOptions.find(({ value }) => value === `${maintenanceContract?.closing_to_due_in_days}`)
                  ? {
                    label: `D+${monthDaysOptions.find(({ value }) => value === `${maintenanceContract?.closing_to_due_in_days}`)?.label}`,
                    value: maintenanceContract?.closing_to_due_in_days
                  }
                  : null
              }
              options={monthDaysOptions.map((day) => ({ label: `D+${day.label}`, value: day.value }))}
              triggerOnChange={submit}
              isDisabled={disableFields}
              errorMessage={errors.closing_to_due_in_days?.message || ' '}
              markAsRequired
            />
          </div>
        </div>
      }
    />
  )
}
